// extracted by mini-css-extract-plugin
module.exports = {"UseCasesList":"UseCasesList_UseCasesList__2B5ch"};